import CallToActionButton from '@/components/landingPage/CallToActionButton';
import Image from 'next-export-optimize-images/image';

const SuccessStories = ({
  CTAButtonVisibleOnMobile,
  buttonText,
}: {
  CTAButtonVisibleOnMobile?: boolean;
  buttonText?: string;
}) => {
  return (
    <div className={`flyntComponent themeLight lg:py-20 py-5 bg-ovi-ivory-1`} is="flynt-grid-stories">
      <div className="container centerMaxWidthContainer">
        <div className="preContent preContent--0" data-mobile-align="mobileAlignLeft">
          <h2>
            <span className="x_41d870ef x_47b745f5">
              <span className="x_aded4464">Unsere Erfolgsgeschichten</span>
            </span>
          </h2>
        </div>
        <div className="content">
          <div className="grid">
            <div className="grid-item">
              <div is="flynt-card-story" className="cardStory">
                <figure className="cardStory-figure">
                  <Image
                    className="figure-image cardStory-image boxRadius lazyloaded"
                    src="/images/oviva-patient-heide.webp"
                    width={540}
                    height={492}
                    alt="Oviva Patientin Heide vorher"
                  />
                  <b className="cardStory-pill themeReset">-22 kg</b>
                </figure>
                <div className="cardStory-body">
                  <p className="cardStory-title h6">Heide</p>
                  <div className="cardStory-footer">
                    <div className="cardStory-rate">
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                    </div>
                    <q className="cardStory-comment">
                      Das Programm hat bisher all meine Erwartungen und Träume übertroffen. Die
                      Verbesserungen meiner Gesundheit waren die Mühe absolut wert. Es macht mir
                      Spaß, die Oviva-App zu nutzen!
                    </q>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid-item">
              <div is="flynt-card-story" className="cardStory">
                <figure className="cardStory-figure">
                  <Image
                    className="figure-image cardStory-image boxRadius lazyloaded"
                    src="/images/oviva-patient-ashlee.webp"
                    alt="Oviva Patientin Ashlee vorher"
                    width={540}
                    height={492}
                  />
                  <b className="cardStory-pill themeReset">-16 kg</b>
                </figure>
                <div className="cardStory-body">
                  <p className="cardStory-title h6">Ashlee</p>
                  <div className="cardStory-footer">
                    <div className="cardStory-rate">
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                    </div>
                    <q className="cardStory-comment">
                      Dank Oviva habe ich nicht nur 16 kg abgenommen, sondern auch meine Freude am
                      Kleidung shoppen und mein Selbstbewusstsein zurückgewonnen. Die ganze
                      Erfahrung hat mein Leben verändert – ich fühle mich einfach großartig!
                    </q>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid-item">
              <div is="flynt-card-story" className="cardStory">
                <figure className="cardStory-figure">
                  <Image
                    className="figure-image cardStory-image boxRadius lazyloaded"
                    src="/images/oviva-patient-martin.webp"
                    width={540}
                    height={492}
                    alt="Oviva Patient Martin vorher"
                  />
                  <b className="cardStory-pill themeReset">-25 kg</b>
                </figure>
                <div className="cardStory-body">
                  <p className="cardStory-title h6">Martin</p>
                  <div className="cardStory-footer">
                    <div className="cardStory-rate">
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      <i className="icon-star">
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.103.817a1 1 0 0 1 1.794 0l2.985 6.048a1 1 0 0 0 .753.547l6.675.97a1 1 0 0 1 .554 1.706l-4.83 4.708a1 1 0 0 0-.288.885l1.14 6.648a1 1 0 0 1-1.45 1.054l-5.97-3.138a1 1 0 0 0-.931 0l-5.97 3.138a1 1 0 0 1-1.451-1.054l1.14-6.648a1 1 0 0 0-.288-.885l-4.83-4.708a1 1 0 0 1 .554-1.706l6.675-.97a1 1 0 0 0 .753-.547L12.103.817Z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                    </div>
                    <q className="cardStory-comment">
                      Ich bin schon an zig Diäten gescheitert. Oder die an mir. Aber die Tipps und
                      Motivation der Ernährungsberaterin im Chat waren einfach super. Die haben mir
                      geholfen, mein Ziel nicht aus den Augen zu verlieren. Und genau deswegen habe
                      ich es auch geschafft, bis heute durchzuhalten.
                    </q>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="postContent-button">
            <CallToActionButton
              visibleOnMobile={CTAButtonVisibleOnMobile}
              buttonText={buttonText}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessStories;
